import { Capacitor } from '@capacitor/core';

const API_BASE = Capacitor.isNativePlatform() ? 'https://www.blitz-news.ro' : '';
const CACHE_KEY = 'blitz_ads_enabled';

// Ads aren't wired up yet. This just keeps a cached copy of the admin's
// on/off switch (Content Management → Reclame, backed by api/settings.js)
// so that whenever ad components are built, they can call getAdsEnabled()
// and render nothing while it's off.
export function getAdsEnabled() {
  try { return JSON.parse(localStorage.getItem(CACHE_KEY) ?? 'true'); } catch { return true; }
}

export async function refreshAdsEnabled() {
  try {
    const res = await fetch(`${API_BASE}/api/settings`);
    const data = await res.json();
    if (typeof data.adsEnabled === 'boolean') {
      localStorage.setItem(CACHE_KEY, JSON.stringify(data.adsEnabled));
    }
  } catch {}
}
